import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
import { Observable,Subject,BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private _changePassUrl = `${environment.api}/Setting/changePassword`;
  private _checkEmailExitUrl = `${environment.api}/Setting/checkEmailExit`;
  private _getProfileInfoUrl = `${environment.api}/Setting/getProfileInfo`;
  private _uploadProfilePicUrl = `${environment.api}/Setting/uploadProfilePic`;
  private _updateProfileUrl = `${environment.api}/Setting/updateProfile`;
  
  constructor(private http: HttpClient) { }


  //// this is use auto navigation reload
  private profileSource = new BehaviorSubject('');
  CurrentProfile = this.profileSource.asObservable();
 
  changeCurrentProfile(userProfile: any) {
    //console.log(userProfile);  
   this.profileSource.next(userProfile)
  }
  ///end 

  changeSuperPassword(data)
  {
     return this.http.post<any>(this._changePassUrl,data);
  }

  checkEmailExit(data)
  {
     return this.http.post<any>(this._checkEmailExitUrl,data);
  }

  getProfileInfo(data)
  {
     return this.http.post<any>(this._getProfileInfoUrl,data);
  }

  updateProfile(data)
  {
     return this.http.post<any>(this._updateProfileUrl,data);
  }

  uploadProfilePic(data)
  {
     return this.http.post<any>(this._uploadProfilePicUrl,data);
  }



}
